import React, { useEffect } from 'react';
import './Logout.css';

function Logout ({ isOpen, logoutErrorText}) {

  function onClose() {
      window.sessionStorage.clear();
      window.location.href = '/';
  }

  if (!isOpen) return null;

  return (
    <div className="logout-modal">
      <div className="logout-modal-content">
        <h1 className="logout-modal-content title">ERROR!</h1>
        <h2>{logoutErrorText}</h2>
        <h2>You will be logged out when you click 'OK' below.
        </h2>
        <p></p>
        <button
          className="logout-btn"
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default Logout;
